import script from "./DeviceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceItem.vue?vue&type=script&setup=true&lang=js"

import "./DeviceItem.vue?vue&type=style&index=0&id=cbc2e3b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbc2e3b2"]])

export default __exports__